import { render, staticRenderFns } from "./paymentRecordsList.vue?vue&type=template&id=24622f34"
import script from "./paymentRecordsList.vue?vue&type=script&lang=js"
export * from "./paymentRecordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports